import { createSelector } from '@reduxjs/toolkit';
import { prepareTableParams } from 'shared/utils/prepare-table-params';
import type { EducationClassesTableState } from './types';

export const selectEducationClassesTableState = (state: {
  educationClassesTable: EducationClassesTableState;
}) => state.educationClassesTable;

export const educationClassesTableSelectors = {
  getTableParams: createSelector(selectEducationClassesTableState, (state) =>
    prepareTableParams(state.tableParams),
  ),
  getTableFilters: createSelector(selectEducationClassesTableState, (state) => state.tableFilters),
};
